/**
 * Els recursos externs del menú «Recursos» de la barra superior.
 *
 * Afegir-ne un és afegir una entrada aquí i res més: el menú es dibuixa sol a
 * partir d'aquesta llista i l'ordre de la llista és l'ordre en què surten.
 *
 * El text va aquí i no als fitxers de traducció a posta. Un recurs és una cosa
 * sola —un nom propi, un enllaç i una frase que diu què hi trobaràs— i tenir-ho
 * repartit entre quatre fitxers voldria dir que afegir-ne un fos tocar-ne
 * quatre, i que tard o d'hora un quedés a mitges. Les etiquetes de la interfície
 * que envolten la llista (el títol del menú) sí que són a les traduccions.
 *
 * El nom **no es tradueix**: és com es diu el lloc, i traduir-lo faria més
 * difícil trobar-lo. La frase de sota sí.
 */

export const RECURSOS = [
  {
    id: 'ec-foresight',
    nom: 'Competence Centre on Foresight',
    url: 'https://knowledge4policy.ec.europa.eu/foresight_en',
    descripcio: {
      ca: 'El centre de prospectiva de la Comissió Europea: mètodes, informes i megatendències.',
      es: 'El centro de prospectiva de la Comisión Europea: métodos, informes y megatendencias.',
      en: "The European Commission's foresight centre: methods, reports and megatrends."
    }
  }
];

export default RECURSOS;
